export default "__VITE_ASSET__60554978__"